<template>
  <div>
    <div v-if="!showTips" class="page-container">
      <div class="icon" style="margin-top: 600px;">
        <p>必孚手机版</p>
        <img src="@/assets/image/app_icon.png" style="width: 240px; height: 240px;">
      </div>
      <div class="tips">
        <div class="tips-btn" @click="open">立即打开</div>
        <div class="tips-btn" style="margin-top: 60px;" @click="download">立即下载</div>
        <div style="font-size: 40px; margin-top: 100px; color: #2c5073;">
          <p>若您已安装APP, 请点击“立即打开”</p>
          <p style="margin-top: 20px;">若您未安装APP, 请点击“立即下载”</p>
        </div>
      </div>
    </div>
    <div v-if="showTips">
      <img src="@/assets/image/tips.png" style="width: 100%; height: 100%">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showTips: false
    }
  },
  mounted () {
    if (window.location.href.indexOf('?') === -1) {
      setTimeout(() => {
        location.reload()
      }, 1000)
    }
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) && (ua.match(/MicroMessenger/i).toString() === 'micromessenger')) {
      this.showTips = true
    }
  },
  methods: {
    open () {
      const id = (window.location.href.split('?')[1]).split('=')[1]
      window.location.href = `btc://com.beeftochina.beefmeat?artical=${id}`
    },
    download () {
      window.location.href = 'https://www.beeftochina.com.cn/common/download/app/beeftochina_1.8.26.apk'
    }
  }
}
</script>

<style scoped>
.page-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #1a92ff;
  font-size: 65px;
}
.tips {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tips-btn {
  width: 500px;
  height: 130px;
  line-height: 130px;
  border: 3px solid #2c5073;
  border-radius: 20px!important;
  font-size: 60px;
  text-align: center;
}
</style>
